import { FileText } from "lucide-react";

import { Field, FieldLayout, hasConflicts } from "@/src/components/cards/common";
import EHRCard from "@/src/components/cards/ehr-cards/ehr-card";
import { EHRDocument } from "@/src/models/ehr-document";

const DOCUMENT_FIELDS: Field[] = [
  { key: "description", label: "Description", comparable: false },
  { key: "ehrId", label: "Document ID", comparable: false },
  { key: "createdAt", label: "Created Date", type: "datetime", comparable: false },
  { key: "status", label: "Status", comparable: false },
  { key: "documentDate", label: "Document Date", type: "date", comparable: true },
  { key: "assignedTo", label: "Assigned To", comparable: true },
  { key: "providerId", label: "Provider ID", comparable: true },
  { key: "internalNote", label: "Internal Note", comparable: true, colSpan: 2 },
  { key: "actionNote", label: "Action Note", comparable: false, colSpan: 2 },
];

interface EHRDocumentCardProps {
  document: EHRDocument | null;
  expectedDocument?: EHRDocument | null;
}

export default function EHRDocumentCard({ document, expectedDocument }: EHRDocumentCardProps) {
  let hasAnyConflicts = false;

  if (expectedDocument) {
    hasAnyConflicts = hasConflicts(DOCUMENT_FIELDS, document, expectedDocument);
  }

  return (
    <EHRCard
      icon={<FileText />}
      title="Document Information"
      missingData={document === null}
      hasAnyConflicts={hasAnyConflicts}
    >
      {document && (
        <FieldLayout
          fields={DOCUMENT_FIELDS}
          patient={document}
          compareMode={expectedDocument !== null && expectedDocument !== undefined}
          secondaryObject={expectedDocument}
          compareAgainstTitle="Expected"
        />
      )}
      {!document && <p className="text-sm text-muted-foreground">No document information available</p>}
    </EHRCard>
  );
}
